import { useOfficialTerms } from "../../lib/officialTerms";

/** Avis public de suspension préventive (Registre maître) — remplace tout formulaire d'inscription / paiement. */
export const SuspensionNotice = ({ event }) => {
  const T = useOfficialTerms();
  const text = event?.temporary_text || T.temporary_official_text || "";
  return (
    <div className="space-y-5" data-testid="jm-suspension-notice">
      <div className="rounded-2xl border border-amber-500/50 bg-amber-500/10 p-6">
        <div className="text-[10px] tracking-[0.3em] text-amber-300 mb-2">STATUT</div>
        <h2 className="text-base md:text-lg font-bold text-amber-100" data-testid="jm-suspension-status">{event?.public_status_label || T.suspension_status_label}</h2>
        <p className="text-sm text-zinc-200 mt-3" data-testid="jm-suspension-message">{event?.suspension_message || T.suspension_public_message}</p>
      </div>
      <div className="rounded-2xl border border-zinc-800 bg-zinc-950 p-6 text-sm text-zinc-300 space-y-2" data-testid="jm-temporary-text">
        <div className="text-[10px] tracking-[0.3em] text-zinc-500">{T.event_title?.toUpperCase()} · {T.event_subtitle?.toUpperCase()}</div>
        {text.split("\n").filter(Boolean).map((l, i) => <p key={i} className={i === 0 ? "font-semibold text-zinc-100" : ""}>{l}</p>)}
        <div className="text-xs text-zinc-500 pt-3 border-t border-zinc-900">{T.institute_name} · {T.event_address} · {T.phone} · {T.email}</div>
      </div>
    </div>
  );
};
